module.exports = __webpack_public_path__ + "static/media/arrow-left.92be9eb6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/images/school_money/arrow-left.svg
// module id = 616
// module chunks = 0